import { DocumentCreationInfo } from './document-creation-info.model';

export class AgreementCreationInfo {
  documentCreationInfo: DocumentCreationInfo;

  constructor(creationInfo?: any) {
    creationInfo = creationInfo || {};
    this.documentCreationInfo = creationInfo.documentCreationInfo
      ? new DocumentCreationInfo(creationInfo.documentCreationInfo)
      : null;
  }
}
